import React from 'react';

import css from './TopbarSearchForm.module.css';

const IconSearchDesktop = () => (
  <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="#8a8f98" strokeWidth="2"
    className={css.iconSvg}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z">
    </path>
  </svg>
);

export default IconSearchDesktop;
